module.exports = __webpack_public_path__ + "static/media/nadinala_end.2c4e3d50.png";